import { Contact, ContactSummary } from '../contact/contact';
import { AuditDetails, Entity, EntityLink } from '../entity';
import { InvoiceBillingCompany } from '../invoicing/invoicing';
import { TaxInclusiveOption } from '../purchase/purchase.order.line';
import { ItemSection } from '../quotes/quote.pro';
import { Attachment } from '../shared/attachment';

export enum SaleOrderStatus {
    New = "New",
    Invoiced = 'Invoiced',
    Cancelled = 'Cancelled'
}

/** Entity-framework command ids for Sales Order EF command routing. InvoiceVoided is system-only and lives on SaleOrderLifecycleCommand — it is deliberately not routable here. */
export enum SaleOrderCommandId {
    ConvertToInvoice = 'convertToInvoice',
    Cancel = 'cancel',
}

export interface SaleOrder extends Entity, AuditDetails {
    saleOrderNumber?: string;
    date?: Date;
    expiryDate?: Date;

    account: Contact,
    contact?: ContactSummary;
    customerRef?: string;

    // Same persisted shape as Invoice/Bill. Documents stored before this widening carry only {_id, name}.
    billingCompany?: InvoiceBillingCompany;

    status: SaleOrderStatus;
    sections?: ItemSection[];
    taxInclusiveOption?: TaxInclusiveOption;

    totalEx?: number;
    totalInc?: number;
    totalTax?: number;

    links?: EntityLink[];
    priceList: Entity;
    theme?: Entity;
    notes?: string;
    attachments?: Attachment[];
}
